import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-889338b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "footer" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = { class: "links" }
const _hoisted_4 = {
  href: "https://www.teladochealth.com/terms-of-service/",
  target: "_blank"
}
const _hoisted_5 = {
  href: "https://www.teladoc.com/notice-of-privacy-practices/",
  target: "_blank"
}
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { href: "tel:911" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "tel:988" }, "988", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "tel:18002738255" }, "800-273-8255", -1))
const _hoisted_10 = { class: "copyRight" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.$t('links.terms')), 1),
      _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$t('links.privacy')), 1),
      _createVNode(_component_router_link, { to: {name: 'SiteMap'} }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('links.siteMap')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("p", _hoisted_6, [
      _createTextVNode(_toDisplayString(_ctx.$t('text1',{brandName: _ctx.brandName})), 1),
      _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t('links.call911')), 1),
      _createTextVNode(_toDisplayString(_ctx.$t('text2')), 1),
      _hoisted_8,
      _createTextVNode(_toDisplayString(_ctx.$t('text3')), 1),
      _hoisted_9,
      _createTextVNode(".")
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("span", null, "© " + _toDisplayString(_ctx.companyName) + " " + _toDisplayString(_ctx.$t('copyright')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.version), 1)
    ])
  ]))
}